<div class="reservation-container">
  <div class="reservation-topbar">
    <div class="topbar-left">
      <h1>
        Reservations
        <small>Manage item reservations for jobs, events, and customers</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i> <span>Item Rental</span> / <span class="current">Reservations</span>
        <span class="separator">|</span>
        <span class="time"><i class="bi bi-clock"></i> {{ timestamp() }}</span>
      </div>
    </div>
    <div class="topbar-right">
      <div class="search-box">
        <i class="bi bi-search"></i>
        <input type="text" placeholder="Filter by item name..." [ngModel]="searchQuery()"
          (ngModelChange)="searchQuery.set($event)" />
      </div>
      <button class="btn btn-outline btn-sm" (click)="exportData()">
        <i class="bi bi-download"></i> Export
      </button>
      <button class="btn btn-primary" (click)="openReservationModal()">
        <i class="bi bi-plus-circle"></i> New Reservation
      </button>
    </div>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon blue">
        <i class="bi bi-calendar-event"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Total Reservations</div>
        <div class="stat-value">{{ reservationStats().total }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon green">
        <i class="bi bi-cash-coin"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Ready to issue</div>
        <div class="stat-value">{{ reservationStats().readyToIssue }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon blue">
        <i class="bi bi-box-arrow-up-right"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Issued out</div>
        <div class="stat-value">{{ reservationStats().issuedOut }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon amber">
        <i class="bi bi-clock"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Pending</div>
        <div class="stat-value">{{ reservationStats().pending }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon red">
        <i class="bi bi-x-circle"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Cancelled</div>
        <div class="stat-value">{{ reservationStats().cancelled }}</div>
      </div>
    </div>
  </div>

  <div class="view-switch" role="tablist">
    <button
      type="button"
      class="view-tab"
      [class.active]="listView() === 'current'"
      (click)="showCurrentList()"
    >
      <i class="bi bi-calendar-event"></i> Current
    </button>
    <button
      type="button"
      class="view-tab"
      [class.active]="listView() === 'history'"
      (click)="showHistoryList()"
    >
      <i class="bi bi-clock-history"></i> Reservation history
    </button>
  </div>

  <div class="filter-bar">
    <div class="filter-left">
      <div class="filter-group">
        <label><i class="bi bi-tag"></i> Status</label>
        <select [ngModel]="statusFilter()" (ngModelChange)="statusFilter.set($event)">
          @if (listView() === 'history') {
            <option value="">All history</option>
            <option value="checked-out">Checked out</option>
            <option value="returned">Returned</option>
            <option value="cancelled">Cancelled</option>
          } @else {
            <option value="">Pending and confirmed</option>
            <option value="pending">Pending</option>
            <option value="confirmed">Confirmed</option>
            <option value="completed">Ready to issue</option>
          }
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-building"></i> Branch</label>
        <select [ngModel]="branchFilter()" (ngModelChange)="branchFilter.set($event)">
          @if (!branchFilterLocked()) {
            <option value="all">All Branches</option>
          }
          @for (branch of branches(); track branch.id) {
            <option [value]="branch.name">{{ branch.name }}</option>
          }
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-geo-alt"></i> Location</label>
        <select [ngModel]="locationFilter()" (ngModelChange)="locationFilter.set($event)">
          <option value="all">All Locations</option>
          @for (location of locations(); track location.id) {
            <option [value]="location.name">{{ location.name }}</option>
          }
        </select>
      </div>
    </div>
    <div class="filter-right">
      <span class="filter-count">
        @if (listView() === 'history') {
          Showing {{ historyReservations().length }} in history
        } @else {
          Showing {{ filteredReservations().length }} reservations
        }
      </span>
    </div>
  </div>

  <div class="table-wrap">
    <div class="table-scroll">
      @if (listView() === 'history') {
      <table>
        <thead>
          <tr>
            <th>Reservation ID</th>
            <th>Customer</th>
            <th>Item</th>
            <th>Qty</th>
            <th>Branch</th>
            <th>History</th>
            <th>Outcome</th>
          </tr>
        </thead>
        <tbody>
          @for (reservation of historyReservations(); track reservation.id) {
          <tr>
            <td><span class="reservation-id">{{ reservation.reservationNumber }}</span></td>
            <td>{{ reservation.customer }}</td>
            <td>
              <div class="item-info">
                <span class="item-icon"><i class="bi" [class]="findAssetIcon(reservation.equipment)"></i></span>
                <span>{{ reservation.equipment }}</span>
              </div>
            </td>
            <td>{{ reservation.quantityRequested ?? 1 }}</td>
            <td><span class="branch-tag">{{ reservation.branch }}</span></td>
            <td>
              <ol class="history-trail">
                @for (event of reservation.events; track event) {
                  <li>{{ event }}</li>
                }
              </ol>
            </td>
            <td>
              <span class="status-badge" [class]="reservation.outcome">
                {{ historyOutcomeLabel(reservation.outcome) }}
              </span>
            </td>
          </tr>
          } @empty {
          <tr>
            <td colspan="7" class="empty-history">No reservation history for these filters yet.</td>
          </tr>
          }
        </tbody>
      </table>
      } @else {
      <table>
        <thead>
          <tr>
            <th>Reservation ID</th>
            <th>Customer</th>
            <th>Item</th>
            <th>Qty</th>
            <th>Branch</th>
            <th>Location</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (reservation of filteredReservations(); track reservation.id) {
          <tr>
            <td><span class="reservation-id">{{ reservation.reservationNumber }}</span></td>
            <td>{{ reservation.customer }}</td>
            <td>
              <div class="item-info">
                <span class="item-icon"><i class="bi" [class]="findAssetIcon(reservation.equipment)"></i></span>
                <span>{{ reservation.equipment }}</span>
              </div>
            </td>
            <td>{{ reservation.quantityRequested ?? 1 }}</td>
            <td><span class="branch-tag">{{ reservation.branch }}</span></td>
            <td><span class="location-tag">{{ reservation.location }}</span></td>
            <td>{{ formatDate(reservation.startDate) }}</td>
            <td>{{ formatDate(reservation.endDate) }}</td>
            <td><span class="status-badge" [class]="reservation.status">{{ reservationStatusLabel(reservation.status) }}</span></td>
            <td class="actions-cell">
              <div class="row-actions">
                <button type="button" class="btn-action edit" title="Edit reservation"
                  (click)="openEditModal(reservation)">
                  <i class="bi bi-pencil"></i>
                </button>
                @if (auth.hasPermission('delete_orders')) {
                <button
                  type="button"
                  class="btn-action delete"
                  title="Delete reservation"
                  [disabled]="reservationIsIssued(reservation)"
                  (click)="deleteReservation(reservation)"
                >
                  <i class="bi bi-trash"></i>
                </button>
                }
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
      }
    </div>
  </div>

  <div class="pagination-bar">
    <div class="pagination-info">
      @if (listView() === 'history') {
        Showing <span>{{ historyReservations().length }}</span> history records
      } @else {
        Showing <span>1</span> to <span>{{ filteredReservations().length }}</span> of <span>{{
          filteredReservations().length }}</span> reservations
      }
    </div>
  </div>
</div>

<!-- Reservation Modal -->
<div class="modal-overlay" [class.open]="showReservationModal()" (click)="closeModalOnBackdrop($event)">
  <div class="modal modal-large">
    <div class="modal-header">
      <h2>
        <i class="bi" [class]="isEditing() ? 'bi-pencil' : 'bi-plus-circle'"></i>
        {{ isEditing() ? 'Edit Reservation' : 'New Reservation' }}
      </h2>
      <button class="close-btn" (click)="closeReservationModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">
      @if (isEditing()) {
        <p class="edit-hint">
          <i class="bi bi-info-circle"></i>
          @if (reservationIsIssued(editingSnapshot())) {
            This item has been issued. Status cannot be changed. You can still change the dates.
          } @else if (canRemoveReservedItems()) {
            You can change the dates and status, and remove items that are no longer needed.
          } @else {
            You can change the dates and status.
          }
        </p>
      }

      <div class="form-row">
        <div class="form-group">
          <label>Customer / Case <span class="required">*</span></label>
          @if (isEditing()) {
            <input type="text" [value]="editingSnapshot()?.customer ?? ''" readonly />
          } @else {
            <input type="text" placeholder="Enter customer name..." [ngModel]="formCustomer()"
              (ngModelChange)="formCustomer.set($event)" />
          }
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Branch <span class="required">*</span></label>
          @if (isEditing()) {
            <input type="text" [value]="editingSnapshot()?.branch ?? ''" readonly />
          } @else {
            <select [ngModel]="formBranch()" (ngModelChange)="onFormBranchChange($event)">
              <option value="">Select Branch</option>
              @for (branch of branches(); track branch.id) {
                <option [value]="branch.id">{{ branch.name }}</option>
              }
            </select>
          }
        </div>
        <div class="form-group">
          <label>Store Location <span class="required">*</span></label>
          @if (isEditing()) {
            <input type="text" [value]="editingSnapshot()?.location || '—'" readonly />
          } @else {
            <select [ngModel]="formLocation()" (ngModelChange)="onFormLocationChange($event)">
              <option value="">Select Location</option>
              @for (location of formBranchLocations(); track location.id) {
                <option [value]="location.id">{{ location.name }}</option>
              }
            </select>
            @if (!formLocation()) {
              <small class="field-hint">Pick a store location to filter which items are stocked there.</small>
            }
          }
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Item <span class="required">*</span></label>
          @if (isEditing()) {
            <input type="text" [value]="editingSnapshot()?.equipment ?? ''" readonly />
            @if (editUnits().length) {
              <div class="picked-items">
                <p class="picked-title">Reserved items</p>
                @for (unit of editUnits(); track unit.key) {
                  <div class="picked-row">
                    <span>{{ unit.label }}</span>
                    @if (unit.serialNumber) {
                      <span class="picked-serial">{{ unit.serialNumber }}</span>
                    }
                    @if (canRemoveReservedItems()) {
                      <button
                        type="button"
                        class="btn-action delete"
                        title="Remove this item"
                        (click)="removeEditUnit(unit.key)"
                      >
                        <i class="bi bi-x-lg"></i>
                      </button>
                    }
                  </div>
                }
              </div>
              <small class="field-hint">
                @if (canRemoveReservedItems()) {
                  {{ editUnits().length }} still reserved. Remove the ones the customer no longer wants. At least one must stay.
                } @else {
                  {{ editUnits().length }} reserved.
                }
              </small>
            }
          } @else {
            <input
              type="text"
              placeholder="Filter by item name..."
              [ngModel]="equipmentNameFilter()"
              (ngModelChange)="equipmentNameFilter.set($event)"
            />
            <select
              [ngModel]="formEquipment()"
              (ngModelChange)="onFormEquipmentChange($event)"
              [disabled]="equipmentLoading()"
            >
              <option value="">{{ equipmentLoading() ? 'Loading items...' : 'Select Item' }}</option>
              @for (asset of reservableOptions(); track asset.id) {
              <option [value]="equipmentOptionId(asset)">{{ equipmentOptionLabel(asset) }}</option>
              }
            </select>
            @if (availabilityNotice()) {
              <small class="field-hint unavailable-hint">{{ availabilityNotice() }}</small>
            }
            @if (!isEditing() && formEquipment()) {
              <label class="serial-label">Serial number @if (serialOptions().length) { <span class="required">*</span> }</label>
              @if (serialsLoading()) {
                <input type="text" value="Loading serial numbers..." readonly />
              } @else if (serialOptions().length) {
                <select [ngModel]="selectedSerial()" (ngModelChange)="selectedSerial.set($event)">
                  <option value="">Select serial number</option>
                  @for (serial of serialOptions(); track serial.serialNumber) {
                    <option [value]="serial.serialNumber">{{ serial.serialNumber }}</option>
                  }
                </select>
              }
              <button type="button" class="btn btn-outline btn-sm add-item-btn" (click)="addReservationItem()">
                <i class="bi bi-plus-lg"></i> Add item
              </button>
            }
            @if (reservationPicks().length) {
              <div class="picked-items">
                <p class="picked-title">Items on this reservation</p>
                @for (pick of reservationPicks(); track pick.key) {
                  <div class="picked-row">
                    <span>{{ pick.code ? pick.code + ' — ' : '' }}{{ pick.name }}</span>
                    @if (pick.serialNumber) {
                      <span class="picked-serial">{{ pick.serialNumber }}</span>
                    }
                    <span class="picked-available">{{ pickAvailableCount(pick) }} available</span>
                    <button type="button" class="btn-action delete" title="Remove" (click)="removeReservationPick(pick.key)">
                      <i class="bi bi-x-lg"></i>
                    </button>
                  </div>
                }
              </div>
            }
          }
        </div>
        <div class="form-group">
          <label>Quantity</label>
          @if (isEditing()) {
            <input type="text" [value]="editUnits().length || editingSnapshot()?.quantityRequested || 1" readonly />
          } @else {
            <div class="available-qty-box" [class.zero]="!!formEquipment() && selectedItemAvailable() <= 0">
              <span class="available-qty-label">{{ selectedReservable()?.name || 'Selected item' }}</span>
              <span class="available-qty-value">{{ formEquipment() ? selectedItemAvailable() : '—' }}</span>
            </div>
            <small class="field-hint">
              @if (selectedReservable(); as item) {
                {{ selectedItemAvailable() }} available under {{ item.name }}.
              } @else {
                Select an item to see how many are available.
              }
            </small>
          }
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Start Date <span class="required">*</span></label>
          <input type="date" [ngModel]="formStartDate()" (ngModelChange)="formStartDate.set($event)" />
        </div>
        <div class="form-group">
          <label>End Date <span class="required">*</span></label>
          <input type="date" [ngModel]="formEndDate()" (ngModelChange)="formEndDate.set($event)" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Status</label>
          <select
            [ngModel]="formStatus()"
            (ngModelChange)="formStatus.set($event)"
            [disabled]="reservationIsIssued(editingSnapshot())"
          >
            <option value="pending">Pending</option>
            <option value="confirmed">Confirmed</option>
            <option value="completed">Ready to issue</option>
            @if (formStatus() === 'issued' || editingSnapshot()?.status === 'issued') {
              <option value="issued">Issued out</option>
            }
            <option value="cancelled">Cancelled</option>
          </select>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-outline" (click)="closeReservationModal()">Cancel</button>
      <button class="btn btn-primary" (click)="saveReservation()">
        <i class="bi bi-check-lg"></i> {{ isEditing() ? 'Save Changes' : 'Create Reservation' }}
      </button>
    </div>
  </div>
</div>

<!-- Toast Notification -->
<div class="toast-container" [class.show]="showToast()">
  <div
    class="toast"
    [class.success]="toastType() === 'success'"
    [class.error]="toastType() === 'error'"
    [class.info]="toastType() === 'info'"
  >
    <div class="toast-icon">
      @if (toastType() === 'error') {
        <i class="bi bi-x-circle-fill"></i>
      } @else if (toastType() === 'info') {
        <i class="bi bi-info-circle-fill"></i>
      } @else {
        <i class="bi bi-check-circle-fill"></i>
      }
    </div>
    <div class="toast-content">
      <div class="toast-title">
        {{ toastType() === 'error' ? 'Error' : toastType() === 'info' ? 'Notice' : 'Success!' }}
      </div>
      <div class="toast-message">{{ toastMessage() }}</div>
    </div>
    <button class="toast-close" (click)="closeToast()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>
